import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LocationClass;
function Location() {
  if (LocationClass === VOID) {
    class $ {
      constructor(line, column) {
        this.w46_1 = line;
        this.x46_1 = column;
      }
      toString() {
        return 'Location(line = ' + this.w46_1 + ', column = ' + this.x46_1 + ')';
      }
    }
    initMetadataForClass($, 'Location');
    LocationClass = $;
  }
  return LocationClass;
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ {
      constructor(message, locations, path, extensions, nonStandardFields) {
        this.y46_1 = message;
        this.z46_1 = locations;
        this.a47_1 = path;
        this.b47_1 = extensions;
        this.c47_1 = nonStandardFields;
      }
      toString() {
        return 'Error(message = ' + this.y46_1 + ', locations = ' + toString(this.z46_1) + ', path=' + toString(this.a47_1) + ', extensions = ' + toString(this.b47_1) + ', nonStandardFields = ' + toString(this.c47_1) + ')';
      }
    }
    initMetadataForClass($, 'Error');
    ErrorClass = $;
  }
  return ErrorClass;
}
//region block: exports
export {
  Location as Location25t453jk43ktl,
  Error_0 as Error3q6zoyx198bpg,
};
//endregion

//# sourceMappingURL=Error.mjs.map
